// import css from "./card.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/deleteSrc.svg";
// import arrowImp from "../../../img/arrowDownPick.png";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import transliterate from "../../../function/transliterate";

// export default function ProdInCard({
//   el,
//   handleQuantityChange,
//   removeProduct,
// }) {
//   const navigate = useNavigate();
//   const [countProd, setCountProd] = useState(el.quantity);

//   const changeStateDown = () => {
//     if (countProd > 1) {
//       const newCount = countProd - 1;
//       setCountProd(newCount);
//       handleQuantityChange(el.uid, newCount);
//     }
//   };

//   const changeStateUp = () => {
//     const newCount = countProd + 1;
//     setCountProd(newCount);
//     handleQuantityChange(el.uid, newCount);
//   };

//   const goToProduct = () => {
//     navigate(`/product/${transliterate(el.bookName)}`);
//   };

//   return (
//     <div className={css.prodInCardWrap}>
//       <img src={el.imageList[0]} alt={el.bookName} className={css.bookFoto} />

//       <div className={css.prodInfoWrap}>
//         <h1 className={css.booksNameCard} onClick={goToProduct}>
//           {el.bookName}
//         </h1>

//         <div className={css.chousLangSelect}>
//           <select className={css.customSelectInCard}>
//             <option value="0">Українською</option>
//           </select>
//           <img src={arrowImp} className={css.arrowDown} alt="arrow" />
//         </div>

//         <div className={css.chousLangSelect}>
//           <select className={css.customSelectInCard}>
//             <option value="0">Паперова</option>
//           </select>
//           <img src={arrowImp} className={css.arrowDown} alt="arrow" />
//         </div>

//         <div className={css.counterWrap}>
//           <div className={css.countPlusMinusValue}>
//             <div className={css.minus} onClick={changeStateDown}>
//               -
//             </div>
//             <div className={css.countValue}>{countProd}</div>
//             <div className={css.plus} onClick={changeStateUp}>
//               +
//             </div>
//           </div>

//           <div className={css.priceBlock}>
//             {/* {el.isActionPrice && <p className={css.oldPrice}>{el.price} грн</p>} */}
//             {/* {el.bundleDiscount > 0 && !el.isActionPrice && (
//               <p className={css.oldPrice}>{el.price} грн</p>
//             )} */}
//             <h4
//               className={
//                 el.isActionPrice || el.bundleDiscount > 0
//                   ? css.priceRed
//                   : css.price
//               }
//             >
//               {el.finalPrice}
//               <span className={css.priceSpan}> грн</span>
//             </h4>
//           </div>
//         </div>

//         <div className={css.delete} onClick={() => removeProduct(el.uid)}>
//           <HandySvg src={iconSrc} width="25" height="29" />
//         </div>
//       </div>
//     </div>
//   );
// }

import css from "./card.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/deleteSrc.svg";
import arrowImp from "../../../img/arrowDownPick.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import transliterate from "../../../function/transliterate";

export default function ProdInCard({
  el,
  handleQuantityChange,
  removeProduct,
}) {
  const navigate = useNavigate();
  const [countProd, setCountProd] = useState(el.quantity);

  const changeStateDown = () => {
    if (countProd > 1) {
      const newCount = countProd - 1;
      setCountProd(newCount);
      handleQuantityChange(el.uid, newCount);
    }
  };

  const changeStateUp = () => {
    const newCount = countProd + 1;
    setCountProd(newCount);
    handleQuantityChange(el.uid, newCount);
  };

  const goToProduct = () => {
    navigate(`/product/${transliterate(el.bookName)}`);
  };

  return (
    <div className={css.prodInCardWrap}>
      <img src={el.imageList[0]} alt={el.bookName} className={css.bookFoto} />

      <div className={css.prodInfoWrap}>
        <h1 className={css.booksNameCard} onClick={goToProduct}>
          {el.bookName}
        </h1>

        <div className={css.chousLangSelect}>
          <select className={css.customSelectInCard}>
            <option value="0">Українською</option>
          </select>
          <img src={arrowImp} className={css.arrowDown} alt="arrow" />
        </div>

        <div className={css.chousLangSelect}>
          <select className={css.customSelectInCard}>
            <option value="0">Паперова</option>
          </select>
          <img src={arrowImp} className={css.arrowDown} alt="arrow" />
        </div>

        <div className={css.counterWrap}>
          <div className={css.countPlusMinusValue}>
            <div className={css.minus} onClick={changeStateDown}>
              -
            </div>
            <div className={css.countValue}>{countProd}</div>
            <div className={css.plus} onClick={changeStateUp}>
              +
            </div>
          </div>

          <div className={css.priceBlock}>
            {/* {el.isActionPrice && <p className={css.oldPrice}>{el.price} грн</p>} */}
            {/* {el.bundleDiscount > 0 && !el.isActionPrice && (
              <p className={css.oldPrice}>{el.price} грн</p>
            )} */}
            {/* <h4
              className={
                el.isActionPrice || el.bundleDiscount > 0
                  ? css.priceRed
                  : css.price
              }
            >
              {el.finalPrice}
              <span className={css.priceSpan}> грн</span>
            </h4> */}
            <h4
              className={
                el.isPriceSale ||
                el.isSalePrice ||
                el.isActionPrice ||
                el.isBundlePrice ||
                (el.bundleDiscount && Number(el.bundleDiscount) > 0)
                  ? css.priceRed
                  : css.price
              }
            >
              {el.finalPrice}
              <span className={css.priceSpan}> грн</span>
            </h4>
          </div>
        </div>

        <div className={css.delete} onClick={() => removeProduct(el.uid)}>
          <HandySvg src={iconSrc} width="25" height="29" />
        </div>
      </div>
    </div>
  );
}
